import Box from '@mui/material/Box';
import HeadTittle from '../../../components/HeadTittle';
import routes from '../../../Routes/routes';
import {SingleZoneUpdateApp} from "./Funtionality/SingleZoneUpdateApp";
import DivContainerBody from "../../../components/DivContainerBody";
import DividerWithText from "../../../components/DividerWithText";
import {CustomTextField} from "../../../components/CustomTextField";
import {CustomCheckbox} from "../../../components/CustomCheckbox";
import CustomTimePicker from "../../../components/CustomTimePicker";
import { EditIcon} from "../../../components/buttons/IconButtons";
import ButtonAction from "../../../components/buttons/ButtonAction";
import {MenuItem} from "@mui/material";
import React from "react";
import {CustomSelectAndChildren} from "../../../components/CustomSelectAndChildren";

const UpdateZone = () => {


    const {t,name,setName,isStatus,setIsStatus,getListStatusZone,isCommonArea,setIsCommonArea,
        formDate,setFormDate,toDate,setToDate,handleUpdate,emptyFields,id, isValidHour} = SingleZoneUpdateApp()

    return (
        <DivContainerBody>
            <HeadTittle name={'update'} link={routes.zone.details + id}>
                <ButtonAction
                    id={'btn_upzne_update'}
                    name={'update'}
                    className={'btn-icon-edit'}
                    Icon={EditIcon}
                    onClick={() => handleUpdate()}/>
            </HeadTittle>
            <DividerWithText title={t('data')} spacing={"my-3"} />
            <div className={"row"}>
                <Box className='col-sm-12 col-xxl-6 col-lg-6'>
                    <CustomTextField id={"txt_upzne_name"}
                                     name={"name"}
                                     value={name}
                                     trans={"zone_name"}
                                     type={"text"}
                                     onChange={(e) => setName(e.target.value)}
                                     required
                                     emptyFields={emptyFields}
                    />
                </Box>
                <div className='col-sm-12 col-xxl-6 col-lg-6'>
                    <CustomSelectAndChildren
                                  id={"slt_upzne_status"}
                                  name={"status"}
                                  value={isStatus}
                                  keyName="id"
                                  onChange={(e) => setIsStatus(e.target.value)}
                                  list={getListStatusZone}
                                  trans={"status"}
                                  label={"lbl_upzne_status"}
                                  required
                                  emptyFields={emptyFields}
                                  showNoSelectionOption={false}
                    >
                        {getListStatusZone?.map((item) => (
                            <MenuItem value={item?.id}>
                                {t(item?.name).toUpperCase()}
                            </MenuItem>
                        ))}
                    </CustomSelectAndChildren>
                </div>
            </div>
            <DividerWithText title={t('common_area')}>
                   <div className={"divider-checkbox"}>
                       <CustomCheckbox
                           marginbutton={true}
                           id="cb_cud_is_common_area"
                           checked={isCommonArea}
                           onChange={() => setIsCommonArea(!isCommonArea)}
                           labelId={"lbl_upzne_is_common_area"}
                           label={"is_common_area"}
                           trans={"is_common_area"}
                           name={"isCommonArea"}
                       />
                   </div>
            </DividerWithText>
            <div className={"row"}>
                <h4 className={"ibl-h4-item-contrast my-3"}>{t('service_time')}</h4>
                <div className='col-sm-12 col-md-6 col-xxl-6 col-lg-6 '>
                    <CustomTimePicker
                        title={t('from')}
                        name='formDate'
                        value={isCommonArea ? formDate : null}
                        handleChange={(newValue) => {
                            setFormDate(newValue);
                        }}
                        disabled={!isCommonArea}
                        ampm={false}
                        required={isCommonArea}
                        id={'tp_upzne_form_date'}
                        actions={['accept', 'cancel']}
                        emptyFields={isCommonArea ? emptyFields: undefined}
                        formatValue={false}
                        isValid={isValidHour}
                        helperText={'helper_select_time_range'}
                    />
                </div>
                <div className='col-sm-12 col-md-6 col-xxl-6 col-lg-6 '>

                    <CustomTimePicker
                        title={t('to')}
                        name='toDate'
                        value={isCommonArea ? toDate : null}
                        handleChange={(newValue) => {
                            setToDate(newValue);
                        }}
                        disabled={!isCommonArea}
                        ampm={false}
                        required={isCommonArea}
                        id={'tp_upzne_to_date'}
                        actions={['accept', 'cancel']}
                        emptyFields={isCommonArea ? emptyFields: undefined}
                        formatValue={false}
                        isValid={isValidHour}
                        helperText={'helper_select_time_range'}
                    />
                </div>
            </div>
        </DivContainerBody>
    );
};

export default UpdateZone;
